import { BObjectModel } from '../bodisplay';
import { DashboardCollectionModel } from '../dashboard';
import { BlockTree } from '../blocked';

export enum eAuthMode {
  APICLIENT,
  QUEOVAL,
  EXTRANET,
  INTRANET,
  ELEARNING,
  RECOVERYEXEL,
  RECOVERYERP
}

export enum eAppContext {
  NONE,
  QUEOVAL,
  EXTRANET,
  WEBSTORE,
  QUESTIONNAIRE,
  ELEARNING,
  ESTORE,
  ONLINEMARKET,
  ONLINEMARKETLOG,
  LOGINEX,  // common login extranet
  LOGINEL   // common login elearning
}

export enum eLogMode {
  NONE,
  FULLANGULAR,
  MIXED
}

export enum eConfigKey {
  IMGSIZE = 'MEDIAS_IMG_SIZE',
  VIDEOSIZE = 'MEDIAS_VIDEO_SIZE',
  DOCSIZE = 'MEDIAS_DOC_SIZE',
  AUDIOSIZE = 'MEDIAS_AUDIO_SIZE',
  IMGFOLDER = 'IMAGESFOLDER',
  IMGHTTP = 'IMAGESHTTP',
  ESTORE = 'ESTORE_SITE',
  ESTOREWS = 'ESTORE_WS',
  WEBSTORE = 'WEBSTORE_SITE',
  WEBSTOREWS = 'WEBSTORE_WS',
  STREAM_HTTP = 'QUEOVAL_STREAM',
  STREAM_FOLDER = 'QUEOVAL_STREAM_FOLDER',
  STREAM_URL = 'QUEOVAL_STREAM_URL',
  INTRANET_API = 'INTRANET_API'
}


export class QueovalBase {
  Error: string;
  Alert: string;
  CodedAlerts: Array<Alert>;
  HasError: boolean;
  HasAlert: boolean;
  HasBlockingAlert: boolean;
  HasSomeError: boolean;
  Mode: string;
  Action: string;
}

export class QResult<T> extends QueovalBase {
  Value: T;
}


export class Alert {
  Code: string;
  Message: string;
}

export class BaseQueovalItem {
  public Value: string;
  public Text: string;
}

export class QueovalItem extends BaseQueovalItem {
  public Selected: boolean;
  public Tooltip: string;
}

export class QueovalItemModel extends QueovalBase {
  public Ident: string;
  public Date: Date;
  public queovalItemList: Array<QueovalItem>;
  public UsersBlock: BlockTree;
  public CompteSurEntite: Array<CompteSurEntite>;
  public Boolean: boolean;
  public Boolean2: boolean;
  public columnDefs: any[];
  public rowData: any[];
}
export class CompteSurEntite {
  public IdentEntite: string;
  public LabelEntite: string;
  public LabelCompte: string;
  public IdentCompte: string;
}

export class InitModel extends QueovalBase {
  public Roles: QueovalRole;
  public TranslationLib: Translation;
}

export class MainModel extends QueovalBase {
  public Culture: string;
  public GMT: string;
  public StartPage: string;
  public LoggedUser: ConnectedUser;
  public BlocksList: BlockInfo[];
  public PostMode: string;
  public Theme: string;
  public TranslationLib: Translation;

  public SocieteName: string;
  public CnxConnectLogo: string;
  public CnxConnectLogoFolder: string;
  public CnxConnectLogoB64: string;
  public UserMainLogo: string;
  public UserMainLogoFolder: string;
  public UserMainLogoB64: string;
  public UserMainLogoEL: string;
  public LogoOMsrvPath: string;
  public LogoOMclientPath: string;
  public BandeauOMsrvPath: string;
  public BandeauOMclientPath: string;
  public UserMainLogoELB64: string;
  public UserConnectLogo: string;
  public UserConnectLogoB64: string;
  public IsAdminUser: boolean;
  public IsRapidMode: boolean;
  // public ProviderCTI: string;
  // public PrefixCTI: string;
  // public LineCTI: string;
  public ParamsLocalExe: string;
  public IdPersonne: string;
  public DrtTemps: string;
  // public ShowTraduction: boolean;

  public RaccourciListTOT: Array<MainShortcut>;
  public relation: RelationModel;

  // public RaccourciList: Array<shortcut>;
  // public RaccourciListSup: Array<shortcut>;
  public ClientSearchTypes: Array<QueovalItem>;
  public ClientSearchPage: string;
  public ProfilButton: BaseQueovalControl;

  public SelectedRaccourci: MainShortcut;

  public SelectedRaccourciData: MainActionData;
  public Notifications: NotificationModel;
  public CompanyName: string;
  public CompanyAddress: string;
  public DeleteLogoPath: string;

  public Devise: string;
  public MainTheme: string;

  public facebookLink: string;
  public twitterLink: string;
  public viadeoLink: string;
  public googlePlusLink: string;
  public linkedInLink: string;

  public queoExtranetLink: string;
  public queoElearningLink: string;

}


export class MainSearchRequest {
  public Select: string;
  public From: string;
  public InnerJoinTDOLien: Array<InnerJoinRelation>;
  public Where: string;
  public OrderBy: string;
  constructor() {
    this.InnerJoinTDOLien = [];
  }
}
export class InnerJoinRelation {
  public IdDonnee: string;
  public Origin: string;
  public Relation: string;
}


/* ------------------------------------------------------ */

export class ConfigFile {
  apiUrl: string;       // address main api service url
  appUrl: string;       // address parent app (queoval / portail)
  applogin: string;    // for queoval (FULL-ANG)
  apilogin : string;   // for queoval (MIXED/FULL-ANG)
  UrlAuthWS: string;    // for queoval (MIXED/FULL-ANG)
  loginMode: string;    // for queoval and extranet (MIXED/FULL-ANG)
}

export class AuthModel extends QueovalBase {
  module: string;       // WebStore managemnt
  sample: string;       // WebStore managemnt
  start: string;        // WebStore managemnt
  productid: string;    // WebStore managemnt

  username: string;     // Questionnaire/ELearning management
  password: string;     // Questionnaire/ELearning management
  mode: string;         // Questionnaire/ELearning management

  Token: string;        // response data
  userId: string;       // response data
  baseName: string;     // response data
  userCulture: string;  // response data
  Destination: string;  // response data
  Trad: Translation;    // response data
  Role: QueovalRole;
}

export interface TokenResponse {
  queoval: string;
  culture: string;
  gmt: string;
  role: string;
  isuseradmin: string;
  conflevel: string;
  ok: string;
}

export class ConnectedUser {
  public Ident: string;       // tDOPersonne.Ident
  public Conx_PER: string;    // tDOPersonne.Conx_PER
  public NomfaPER: string;    // tDOPersonne.
  public Pre01PER: string;    // tDOPersonne.
  public NeproPER: string;    // tDOPersonne.
  public PassePER: string;    // tDOPersonne.
  public ConfiPER: string;    // tDOPersonne.
  public EnovfPER: string;    // tDOPersonne.
  public PhotoPER: string;    // tDOPersonne.
  public IsAdmin: boolean;    // tDOPersonne.
  public strLogoConnectEL: string;
  public TwitterLink: string;
  public ViadeoLink: string;
  public YoutubeLink: string;
  public LinkedInLink: string;
  public FacebookLink: string;
}

export class LoginDate {
  public now: Date;
  public day: number;
  public month: number;
  public year: number;
  public hour: number;
  public minute: number;
  constructor() {
    this.now = new Date();
    this.day = this.now.getDate();
    this.month = this.now.getMonth() + 1;
    this.year = this.now.getFullYear();
    this.hour = this.now.getHours();
    this.minute = this.now.getMinutes();
  }
}

export class GlobalParams {

  LoggedUser: ConnectedUser;
  dbname: string;
  culture: string;
  GMT: string;
  appLoginSite: string = '';
  UrlSiteERP: string = '';
  UrlSiteERPWS: string = '';
  UrlExtranetSite: string = '';
  UrlExtranetWS: string = '';
  UrlElearningSite: string = '';
  UrlElearningWS: string = '';
  UrlQuestionnaireSite: string = '';
  UrlQuestionnaireWS: string = '';
  UrlOnlinemarketSite: string = '';
  UrlOnlinemarketWS: string = '';
  UrlPaymentWS: string = '';
  Devise: string;
  appUrl: string;
  apiUrl: string;
  IsAuthorizedAccess: boolean;


  apiLogin: string = '';
  UrlAuthWS: string = '';
  context: eAppContext = eAppContext.NONE;
  loginMode: eLogMode = eLogMode.NONE;
  token: string;
  tokenApiAut: string;
  Role: QueovalRole;
  Translation: Translation;
  ConfigKeys: Array<QueovalDik> = [];  
  ExtranetTrustLevel: string; // to be removed
  theme: string;
  ThemeList: any[];
  IsRestricted: boolean;
  get localTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  constructor(appcontext: eAppContext, appUrl: string, apiUrl: string) {
    const fullAppUrl: boolean = appUrl.substring(0, 4) === 'http' || !appUrl;    
    this.appUrl = fullAppUrl ? appUrl : `${location.protocol}//${window.location.hostname}/${appUrl}/`;

    const fullApiUrl: boolean = apiUrl.substring(0, 4) === 'http' || !apiUrl;
    this.apiUrl = fullApiUrl ? apiUrl : `${location.protocol}//${window.location.hostname}/${apiUrl}/`;

    this.context = appcontext;
    this.loginMode = eLogMode.NONE;
    this.token = '';
    this.culture = 'fr-FR';
    this.Devise = "€";
    this.GMT = '';
    this.appLoginSite = '';
    this.Role = new QueovalRole;
    this.theme = 'Default';
    this.ThemeList = [
      { name: 'Default', cssClass: 'greenTheme' },
      { name: 'Red', cssClass: 'redTheme' },
      { name: 'Blue', cssClass: 'blueTheme' },
      { name: 'Pink', cssClass: 'pinkTheme' }
    ];
  }
}

export class Translation extends QueovalBase {
  public Trads: Array<Localization>;

}

export class Localization {
  public Key: string;
  public Value: string;
}

/* ------------------------------------------------------ */

export class HtmlBase {
  public ID: string;
  public TagName: string;
  public Type: string;
  public ToolTip: string;
  public CloseLabel: string;
  public GroupName: string;
  public Value: string;
  public MoreValues: { [key: string]: string };
  public ValueGeneric: any;
  public Required: boolean;
  public InValid: boolean;
  public ValidExp: string;
  public Disabled: boolean;
  public Visible: boolean;
  public Mask: string;
  public Width: string;
  public Height: string;
  public Src: string;
  public Selectable: boolean;
  public SelectOptionsList: QueovalItem[];
  public OnClick: string;
  public OnClickParams: QueovalItem[];
  public TypeModal: string;
  public OnChange: string;
  public OnFocus: string;
  public OnBlur: string;
  public Temp: string;
  public Code: string;
  public Filter: string;

  constructor(id: string, tagName: string) {
    this.ID = id;
    this.TagName = tagName;
    this.Type = '';
    this.ToolTip = '';
    this.CloseLabel = '';
    this.GroupName = '';
    this.Value = '';
    this.MoreValues = {};
    this.Required = false;
    this.InValid = false;
    this.ValidExp = '';
    this.Disabled = false;
    this.Visible = true;
    this.Width = '';
    this.Height = '';
    this.Src = '';
    this.Selectable = false;
    this.SelectOptionsList = new Array<QueovalItem>();
    this.OnClick = '';
    this.OnClickParams = new Array<QueovalItem>();
    this.TypeModal = '';
    this.OnChange = '';
    this.OnFocus = '';
    this.OnBlur = '';
    this.Mask = '';
    this.Code = '';
  }
}

export class HtmlLink extends HtmlBase {
  Target: string;
  Href: string;
  constructor(id: string, type: string) {
    super(id, 'BUTTON');
    this.Type = type;
  }
}

export class HtmlButton extends HtmlBase {
  constructor(id: string, type: string) {
    super(id, 'BUTTON');
    this.Type = type;
  }
}

/* ------------------------------------------------------ */

export class MenuBlock {
  Target: string;
  Href: string;
  Ident: string;
  Code_BLO: string;
  Name_BLO: string;
  OrdreBLO: string;
  Info_BLO: string;
  CidenBLO: string;
  ParamBLO: string;
  HeighBLO: string;
  TricoBLO: string;
  Type_BLO: string;
  AckPtBLO: string;
  AckKey: string;
}

export class MenuTreeview {
  public Ident: string;
  public Name_TRW: string;
  public ImageTRW: string;
  public Page_TRW: string;
  public ParamTRW: string;
  public DisplTRW: string;
  public OrdreTRW: string;
  public CidenTRW: string;
  public Tsql_TRW: string;
  public AckKey: string;
}

export class TreeviewInfo {
  public TreeviewData: MenuTreeview;
  public Title: string;
  public TargetPage: string;
  public ExeApp: string;
  public ExeParams: string;
  public IsPopUp: boolean;
  public ContextParams: string;
  public CollapseMode: number;
  public IsVisible: boolean;
  public SubItems: TreeviewInfo[];
  public IsSelected: boolean;
}

export class BlockInfo {
  public BlockData: MenuBlock;
  public IsEmpty: boolean;
  public ID: string;
  public Code: string;
  public Titre: string;
  public AdministrationData: string;
  public Type: string;
  public TitreOnClick: string;
  public TreeItems: TreeviewInfo[];
  public isSelected: boolean;
  public class: string;
}

export class MainShortcut {
  public Ident: string;
  public Page_LAN: string;
  public Name_LAN: string;
  public Code_LAN: string;
  public DisplLAN: string;
  public OrdreLAN: string;
  public ImageLAN: string;
  public ParamLAN: string;
  public Info_LAN: string;
  public CidenLAN: string;
  public AckKey: string;
}

export class MainActionData {
  public MainPageURL: string;
  public MainPageDisplayMode: string;
  public ExeParams: string;
  public ContextParams: string;
  public SidebarTitle: string;
  public SidebarTitleClick: string;
  public BlocksList: Array<BlockInfo>;
}

/* ------------------------------------------------------ */

export class BaseQueovalControl {
  public eQueovalControl: string;
  public ID: string;
  public Text: string;
  public Image: string;
  public Position: number;
  public JsonData: string;
  public Params: string;
}

export class NotificationModel extends QueovalBase {
  public Message: string;
  public TotMessages: string;
  public DateBeginAlert: string;
  public NotificationList: Array<string>;
  public AlertList: Array<string>;
}

/* ------------------------------------------------------ */


export class QueovalRole {
  public Id: string;
  public Name: string;
  public Lanceurs: Array<Lanceur>;
  public Autorisation: Array<any>;
  public Questionnaire: Droit;
  public Elearning: Droit;
  public WebStore: Droit;
  public AgendaRdv: Droit;
  public AgendaResaF: Droit;
  public AgendaResaS: Droit;
  constructor() {
    this.Lanceurs = new Array<Lanceur>();
    this.Autorisation = new Array<any>();
    this.Id = '';
    this.Name = '';
  }
}


/* ------------------------------------------------------ */

export class Lanceur {
  public Name: string;
  public Id: string;
  public IdReRoleLanceur: string;
  public Blocks: Array<MenuBlock>;
  public Dashboard: Array<DashboardCollectionModel>;
}

export class Dashboard {
  public Ident: string;
  public Cols_IDA: string;
  public Rows_IDA: string;
  public IdcptIDA: string;
  public TycptIDA: string;
  public ImageIDA: string;
  public Draggable?: boolean;
}

export class Droit {
  /*OLD*/
  public SuperUser: boolean;
  public Ecriture: boolean;
  /*NEW*/
  public Lecture: boolean;
  public Modification: boolean;
  public Suppression: boolean;
  public Admin: boolean;
  public Blocage: boolean;
}

export class Theme {
  public name: string;
  public cssClass: string;
}

export class DataGR {
  Title: string;
  ChartData: number[];
  ChartLabel: string[];
  ChartType: string;
}

//export class Toast {
//  id: string;
//  title: string;
//  faIcon: string;
//  closeAuto: boolean;
//  timeout: number;
//  color: string;
//}

export class QueovalDik {
  public key: string;
  public value: string;
  constructor(key: string, value: string) {
    this.key = key;
    this.value = value;
  }
}

export class GQueovalDik<T, E> {
  public Key: T;
  public Value: E;
  constructor(key: T | null = null, value: E | null = null) {
    if (key != null) {
      this.Key = key;
    }
    if (value != null) {
      this.Value = value;
    }
  }
}
export class ParamApplication {
  constructor(pCode: string = '', pGroup: string = '') {
    this.Code = pCode;
    this.Group = pGroup;
  }
  public Ident: string;
  public Code: string;
  public Group: string;
  public DblValue: number;
  public MonValue: number;
  public DtValue: string;
  public StrValue: string;
  public Info: string;
}

export class BreadDik {
  public key: string;
  public value: any;
  constructor(key: string, value: any) {
    this.key = key;
    this.value = value;
  }
}

export class QueovalParam {
  params: Array<BreadDik> = new Array<BreadDik>();
  model: any | null = null;
  constructor(dicItem: BreadDik | null = null) {
    if (dicItem) {
      this.params.push(dicItem);
    }
  }
}

export class InfoUser {
  ident: string;
  firstName: string;
  lastName: string;
  culture: string;
  mail: string;
  gmt: string;
  theme: string;
  Conx_PER: string;
  PassePER: string;
}

export class LoginModel extends QueovalBase {
  token: string;
  culture: string;
  gmt: string;
  baseName: string;
  confLvl: string;
  apiAdress: string;
  UserFirstName: string;
  userName: string;
  LoggedUser: ConnectedUser;

  constructor() {
    super();
  }
}

export class LoginModel2 extends QueovalBase {
  token: string;
  constructor() {
    super();
  }
}

export class RoleModel extends QueovalBase {
  public Ident: string;
  public Name: string;
  public Roles: Array<any>;
  public Block: Array<any>;
  public Lanceur: Array<any>;
  public Autorisation: Array<any>;
  public ItemsDashboard: Array<any>;
  public Categorie: Array<RoleCategorie>;
  public Users: Array<any>;
  public NewIdent: string;
  public OK: string;
  public RoleUser: Array<RoleUser>;
  public IdRoleLanceur: string;
}

export class RoleUser {
  public Ident: string;
  public UrlImage: string;
  public Nom: string;
  public Prenom: string;
  public IsLicenceERP: boolean;
  public IsLicenceEXTRA: boolean;
}

export class RoleCategorie {
  public NomCategorie: string;
  public Groupe: Array<RoleGroupe>;
}

export class RoleGroupe {
  public NomGroupe: string;
  public Autorisation: Array<RoleAutorisation>;
}

export class RoleAutorisation {
  public FonctAUT: string;
  public idFonctionnalite: string;
  public NomFonctionnalite: string;
  public Acces: boolean;
  public Visibilite: boolean;
}

export class QueovalLibInit {
  public appUrl: string;
  public apiUrl: string;
  public token: string;
  public culture: string;
  public gmt: string;
  public roles: QueovalRole;
  public translation: Translation;
  public configFile: ConfigFile;
  constructor() { }
}

export class InscriptionFormationModel extends QueovalBase {
  public PostMode: string;
  public param1: string;
  public SiteUrl: string;
  public ApiUrl: string;
}

export class QueovalDate {
  annee: string;
  mois: string;
  jour: string;

  constructor(annee = '0', mois = '0', jour = '0') {
    this.annee = annee;
    this.mois = mois;
    this.jour = jour;
    if (Number(mois) < 1 && Number(annee) > 0) {
      this.annee = (Number(annee) - 1).toString();
      this.mois = (12 + Number(mois)).toString();
    }
    else if (Number(mois) > 12 && Number(annee) > 0) {
      this.annee = (Number(annee) + 1).toString();
      this.mois = (Number(mois) - 12).toString();
    }
  }
}

export class QueovalDateRange {
  from: QueovalDate;
  to: QueovalDate;
}

export class QueovalDateTime {
  annee: string;
  mois: string;
  jour: string;
  heures: string;
  minutes: string;
  secondes: string;
  constructor(annee = '0', mois = '0', jour = '0', heures = '', minutes = '', secondes = '') {
    this.annee = annee;
    this.mois = mois;
    this.jour = jour;
    this.heures = heures;
    this.minutes = minutes;
    this.secondes = secondes;
    if (Number(mois) < 1 && Number(annee) > 0) {
      this.annee = (Number(annee) - 1).toString();
      this.mois = (12 + Number(mois)).toString();
    }
  }
}


//export class QueovalDateTime extends QueovalDate {
//  hour: string;
//  min: string;
//  sec: string;
//  gmt: string;
//}
export class InputModel {
  public id: string;
  public value: string;
}


export class BreadcrumbModel {
  mode: string;
  link: string;
  params: string;
  data: QueovalParam;
  title: string;
  clickable: boolean;
  public raccourciData: MainActionData;
  constructor(mode: string, link: string, datas: QueovalParam | null, title: string, clickable: boolean, qsparams: string = '') {
    this.mode = mode;
    this.link = link;
    if (datas && qsparams !== '')
      alert('impossible to set QueovalParam and qsparams at the same time');

    if (qsparams !== '') {
      this.data = new QueovalParam();
      this.params = qsparams;
    }

    if (datas === null) {
      this.data = new QueovalParam();
    } else {
      this.data = datas;
      const p: BreadDik[] = datas.params.filter((d: BreadDik) => d.key === 'params');
      this.params = (p && p.length > 0) ? this.norm(p[0].value) : '';
    }
    this.title = title;
    this.clickable = clickable;
  }

  private norm(paramChain: string): string {
    let prms: string = paramChain;
    if (prms !== '' && prms.includes('\'')) {
      prms = prms.replace(/'/g, '').trim();
    }
    return prms;
  }
}

export class Formateur {
  public BOModel: BObjectModel;
  public strCivilite: string;
  public strNom: string;
  public strPrenom: string;
  public strEmail: string;
  public strImage: string;
}

export class Stage {
  public BOModel: BObjectModel;
  public Text: string;
  public dtDebut: QueovalDate;
  public dtFin: QueovalDate;
}

export class Apprenant {
  BOModel: BObjectModel;
  strIdent: string;
  strNumeroStage: string;
  strNom: string;
  strPrenom: string;
  strEmail: string;
  strNumeroTelFixe: string;
  strNumeroTelPortable: string;
  presence: string;
  infoEmargement: string;
  pathEmargement: string;
  public pathExistButUnfounded: boolean;
}

export class Dragging {
  pageX0: number;
  pageY0: number;
  offset0left: number;
  offset0top: number;
}

export class InfoBo {
  public IdentBo: string;
  public IdRelation: string;
  public IdDonneePere: string;
  public IdDonneeFils: string;
  public IdentSecondBo: string;
}

export class InfoBoLink {
  public ListIdent: Array<string>;
  public IdDonnee: string;
  public IdRelation: string;
  public Origine: string;
}

export class SelectContainer {
  offsetTop: number;
  height: number;
}

export class PageInfo {

  private qsObject: any | null;

  private fullUrl: string;
  get FullUrl(): string {
    return this.fullUrl;
  }
  private url: string;
  get Url(): string {
    return this.url;
  }
  private qs: string;
  get QueryString(): string {
    return this.qs;
  }
  private qpExist: boolean;
  get QueryParamExist(): boolean {
    return this.qpExist;
  }
  get HasQueryString(): boolean {
    return this.qs !== '' && this.qsObject !== null;
  }

  constructor(route: string) {
    this.fullUrl = route;
    this.url = '';
    this.qs = '';
    this.qsObject = null;
    if (this.fullUrl !== '') {
      const fu: string[] = this.fullUrl.split('?');
      this.url = fu[0];
      if (fu.length > 1) {
        this.qs = fu[1];
        this.qsObject = this.splitRoute(this.fullUrl);
      }
    }
  }

  GetQueryParam(queryName: string, caseInsensitive: boolean = true): string {
    if (this.qsObject) {
      const ks: string[] = Object.keys(this.qsObject);
      if (!caseInsensitive) {
        const pn: string = (ks.indexOf(queryName) > -1) ? ks[ks.indexOf(queryName)] : '';
        this.qpExist = pn !== '' ? true : false;
        return pn !== '' ? this.qsObject[pn] : '';
      } else {
        const pn: string | undefined = ks.find(k => k.toLocaleLowerCase() === queryName.toLocaleLowerCase());
        this.qpExist = pn ? true : false;
        return pn ? this.qsObject[pn] : '';
      }
    }
    else
      return '';
  }

  private splitRoute(fullUrl: any): any {
    const urlParams: any = fullUrl
      .split(/[&||?]/)
      .filter((x: string) => {
        return x.indexOf('=') > -1;
      })
      .map((x: string) => {
        return x.split(/=/);
      })
      .map((x: string[]) => {
        x[1] = x[1].replace(/\+/g, ' ');
        return x;
      })
      .reduce((acc: any, current: any) => {
        acc[current[0]] = current[1];
        return acc;
      }, {});
    return urlParams;
  }

}

export class UploadModel2 extends QueovalBase {
  public StreamUpload: StreamUpload;
}

export class StreamExtranetModel extends UploadModel2 {
}

export class StreamQueovalModel extends UploadModel2 {
}

export class StreamUpload {
  public FileName: string;
  public FullPathResult: string;
  public PathResult: string;
  public RegisterMode: string;
  public RootResult: string;
  public SourceFilePath: string;
  public temporyFile: string;
  public ValidData: number;
}

export class CustomFileInfo {
  public FullPath: string;
  public NameExt: string;
  public Name: string;
  public Ext: string;
}

export class FileModel {
  constructor() {
    this.SaveFile = true;
  }
  public DownloadMode: string;
  public Extension: string;
  public Name: string;
  public FullPath: string;
  public folderTypeDoc: string;
  public folderBase: string;
  public Ident: string;
  public SaveFile: boolean;
  public LstIdent: Array<string>;
  public DisplayName: string;
}

export class GridParamGeneric {
  public Val1: string;
  public Val2: string;
  public Val3: string;
  public Val4: string;
  public Val5: string;
  public Selected: boolean;
  public Action: string;
}

export class SessionModel extends QueovalBase {
  public Ident: string;
  public User: string;
  public Key: string;
  public Value: string;
  public BaseDestination: string;
  public Token: string;
}

//#region common login

export class LgError {
  static readonly USER_EMPTY: string = 'Nom d\'utilisateur obligatoire';
  static readonly USER_LONG: string = 'Nom d\'utilisateur trop long';
  static readonly PSWD_EMPTY: string = 'Mot de passe obligatoire';
  static readonly PSWD_LONG: string = 'Mot de passe trop long';
  static readonly DB_EMPTY: string = 'Nom de la base de données obligatoire';
}

export class CheckInput {
  useralert: string = '';
  pswdalert: string = '';
  dbalert: string = '';

  get CheckOK(): boolean {
    return this.useralert === '' && this.pswdalert === '' && this.dbalert === '';
  }

  constructor() {
    this.useralert = '';
    this.pswdalert = '';
    this.dbalert = '';
  }

  check(user: string, pswd: string, clientDB: string, checkDB: boolean): void {
    this.dbalert = checkDB && clientDB === '' ? LgError.DB_EMPTY : '';
    this.useralert = user === '' ? LgError.USER_EMPTY : user.length > 100 ? LgError.USER_LONG : '';
    this.pswdalert = pswd === '' ? LgError.PSWD_EMPTY : pswd.length > 30 ? LgError.PSWD_LONG : '';
  }
}


export class LoginInput {
  Context: eAppContext;     // application name
  AppUrl: string;           // application url
  ApiUrl: string;           // application web service url
  LoginStart: eLoginStart;  // start mode for login component
  CheckDB: boolean;         // check or ignore dbname
  NameDB: string;           // database name
  bigLogoUrl: string;       // login component main logo path
  configFilePath: string;   // json config file for the application
  Storage: QueovalDik[];
  constructor(cntx: eAppContext, logoUrl: string, configUrl: string) {
    this.Context = cntx;
    this.LoginStart = eLoginStart.NONE;
    this.CheckDB = false;
    this.NameDB = '';
    this.bigLogoUrl = logoUrl;
    this.configFilePath = configUrl;
    this.Storage = [];
  }
  getStorage(key: string): string {
    const r: QueovalDik[] = this.Storage.filter((e: QueovalDik) => e.key === key);
    return r.length > 0 ? r[0].value : '';
  }
}

export class LoginOut {
  Context: eLogOutMode;
  LoginOk: boolean;
  constructor(result: boolean, cnt: eLogOutMode) {
    this.LoginOk = result;
    this.Context = cnt;
  }
}

export enum eLogOutMode {
  NONE,
  EXTRANET,
  EXTRANETMAIL,
  EXTRANETAPPLOGIN,
  EXTRANETEXPERT,
  QUESTIONNAIRE,
  ELEARNING,
  ELEARNINGPORTAIL,
  ONLINEMARKET,
  LOGINEX,  // common login extranet
  LOGINEL   // common login elearning
}

export enum eLoginStart {
  NONE,
  COMPLOGIN,        // via login component
  APPLOGIN,         // via app_login site
  MAIL,     // from mail's link (extranet only)
  PORTAIL           // from extranet's link (elearning and questionnaire)
}

//#endregion

//#region registration stagiaire extranet
export class RegistrationStudentModel extends QueovalBase {
  public strIdStage: string;
  public strIdClient: string;
  public bolInscription: boolean;
  public bolBloqueInscription: boolean;
  public isIdClient: boolean;
  public legend: string;
  public strTitre: string;
  public lstStudents: Array<Student>;
}
export class Student {
  public id: string;
  public civility: string;
  public firstName: string;
  public lastName: string;
  public enabled: boolean;
  public selected: boolean;
}

export enum boolInscription {
  false,
  true
}

export class ComboBox {
  public Label: string;
  public Value: string;
  public Selected: boolean;
  constructor(strLabel: string = '', strValue: string = '0', boolSelected: boolean = false) {
    this.Label = strLabel;
    this.Value = strValue;
    this.Selected = boolSelected;
  }
}
//#endregion

export class eStorageInit {
  public static readonly EX_APPLOGIN: string = 'EXTRANET_fromAPPLOGIN';
  public static readonly EL_APPLOGIN: string = 'ELEARNING_fromAPPLOGIN';
  public static readonly EL_EXTRANET: string = 'ELEARNING_fromEXTRANET';
}

export class RelationModel {
  public Ident: string;
  public Groupe: string;
  public PereToFils: string;
  public FilsToPere: string;
  public Info: string;
  public ModeFilsToPere: string;
  public ModePereToFils: string;
  public CodeIdent: string;
  public IdBoPere: string;
  public IdBoFils: string;
  public IdRelOrigine: string;
  public OrdreDeTri: string;
}
